// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfileForm-errorMessage-Oepaw {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.EditProfileForm-displayGrid-sfajB {
    display: grid;
    grid-template-columns: 48% 48%;
    grid-column-gap: 28px;
}

.EditProfileForm-faqImage-QszZp {
    width: 100%;
    max-width: 13px;
    vertical-align: middle;
    margin-bottom: 3px;
}

.EditProfileForm-birthDayFlex-ysWdX {
    display: grid;
    grid-template-columns: 31% 30% 32%;
    grid-gap: 11px;
}

.EditProfileForm-noMarginBottom-HxKWJ {
    margin-bottom: 0px;
}

.EditProfileForm-widthredcd-f4uCw {
    padding: 20px;
    border: 1px solid var(--primary-border);
    width: 100%;
    border-radius: 4px;
}

@media screen and (max-width: 767px) {
    .EditProfileForm-displayGrid-sfajB {
        grid-template-columns: 100%;
    }

    .EditProfileForm-birthDayFlex-ysWdX {
        grid-template-columns: 100%;
        grid-gap: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/EditProfileForm/EditProfileForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;QAC3B,aAAa;IACjB;AACJ","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../../components/utils.css';\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 48% 48%;\n    grid-column-gap: 28px;\n}\n\n.faqImage {\n    width: 100%;\n    max-width: 13px;\n    vertical-align: middle;\n    margin-bottom: 3px;\n}\n\n.birthDayFlex {\n    display: grid;\n    grid-template-columns: 31% 30% 32%;\n    grid-gap: 11px;\n}\n\n.noMarginBottom {\n    margin-bottom: 0px;\n}\n\n.widthredcd {\n    padding: 20px;\n    border: 1px solid var(--primary-border);\n    width: 100%;\n    border-radius: 4px;\n}\n\n@media screen and (max-width: 767px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n\n    .birthDayFlex {\n        grid-template-columns: 100%;\n        grid-gap: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `EditProfileForm-errorMessage-Oepaw`,
	"displayGrid": `EditProfileForm-displayGrid-sfajB`,
	"faqImage": `EditProfileForm-faqImage-QszZp`,
	"birthDayFlex": `EditProfileForm-birthDayFlex-ysWdX`,
	"noMarginBottom": `EditProfileForm-noMarginBottom-HxKWJ`,
	"widthredcd": `EditProfileForm-widthredcd-f4uCw`
};
module.exports = ___CSS_LOADER_EXPORT___;
